import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { CommonApiService } from '../CommonController/common-api-service';
import { FotaApiService } from '../CommonController/fota-api-service';
import { SharedValidators } from '../shared/validators/shared-validators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-fota-batch-details-page',
  templateUrl: './fota-batch-details-page.component.html',
  styleUrls: ['./fota-batch-details-page.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatSelect,
    MatOption,
    CommonSearchComponent,
    CommonPaginationComponent,
  ],
})
export class FotaBatchDetailsPageComponent implements OnInit {
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  searchField = '';
  status = '';
  totalCount = 0;
  fotaBatchDeviceList = [];
  myrefid = '';

  deviceFotaForm: FormGroup;
  fileToUpload: File | null = null; // Store the file outside the form
  fileUploaded = false;

  filter = false;
  viewMode = false;

  iSDevices = false;

  type = [
    { name: 'Chunk', value: 'C' },
    { name: 'Full', value: 'F' },
  ];

  serverName = environment.projectName;
  batchList = [];

  NonInitiated = 0;
  totalAborted = 0;
  totalCompleted = 0;
  totalInitiated = 0;
  totalInProgress = 0;
  totalUploaded = 0;

  startFotaFlag = '';

  userPermissions = [];
  deleteFota = true;
  viewFota = true;
  createFota = true;
  updateFota = true;
  isDownloading: boolean = false;

  constructor(
    public fotaApiService: FotaApiService,
    public router: Router,
    private formBuilder: FormBuilder,
    public datepipe: DatePipe,
    private spinner: NgxSpinnerService,
    public commonApiService: CommonApiService
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    this.setDeviceFotaForm();
    this.myrefid = sessionStorage.getItem('fotaBatchREFID');
    if (this.myrefid === 'NOID') {
      const latest_date = this.datepipe.transform(
        new Date(),
        'dd MMM yyyy hh:mm:ss a'
      );
      this.deviceFotaForm.controls['batchDate'].setValue(latest_date);
    } else {
      this.fetchDataById(this.myrefid);
    }
  }

  checkPermission() {
    this.userPermissions = JSON.parse(
      sessionStorage.getItem('userPermissions')
    );
    this.userPermissions.forEach((element) => {
      if (element.pageName === 'Fota' && element.view === false) {
        this.navigateBack();
      }
      if (element.pageName === 'Fota' && element.create === false) {
        this.createFota = false;
      }
      if (element.pageName === 'Fota' && element.update === false) {
        this.updateFota = false;
      }
      if (element.pageName === 'Fota' && element.delete === false) {
        this.deleteFota = false;
      }
    });
  }

  setDeviceFotaForm() {
    this.deviceFotaForm = this.formBuilder.group({
      batchId: new FormControl(''),
      batchName: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
      ]),
      batchDescription: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
      ]),
      type: new FormControl('', [Validators.required]),
      file: new FormControl('', [Validators.required]),
      batchDate: new FormControl(''),
    });
  }

  fetchDataById(id): void {
    this.spinner.show();
    this.fotaApiService.fetchfotaBatchdetails(id).subscribe({
      next: (res) => {
        try {
          if (res.status) {
            const data = res.data;
            const changedFormat_batchDate = this.datepipe.transform(
              data.createdAt,
              'dd MMM yyyy hh:mm:ss a'
            );
            this.deviceFotaForm = this.formBuilder.group({
              batchId: new FormControl(data.batchId),
              batchName: new FormControl(data.name, [
                SharedValidators.requiredAndNoEmptySpaces,
              ]),
              batchDescription: new FormControl(data.description, [
                SharedValidators.requiredAndNoEmptySpaces,
              ]),
              batchDate: new FormControl(changedFormat_batchDate, [
                Validators.required,
              ]),
            });
            this.spinner.hide();
            this.commonApiService.openSnackbar(res.message);
          }
        } catch (error) {
          this.spinner.hide();
          this.commonApiService.openSnackbar(
            error.error.message ||
              'An error occurred while processing the data.'
          );
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.commonApiService.openSnackbar(error.error.message);
      },
      complete: () => {
        this.viewMode = true;
        this.iSDevices = true;
        this.getfotaBatchDevicdDetails();
      },
    });
  }

  onFileChange(ev) {
    try {
      if (ev.target.files && ev.target.files.length > 0) {
        const file = ev.target.files[0];

        if (file.name.endsWith('.csv')) {
          // Store file in variable (not the form)
          this.deviceFotaForm.get('file').setValue(file.name);
          this.fileToUpload = file;
          this.fileUploaded = true;
        } else {
          this.commonApiService.openSnackbar('Please upload a valid CSV file');
        }
      } else {
        this.fileToUpload = null;
        this.fileUploaded = false;
        this.deviceFotaForm.get('file').setValue('');
      }
    } catch (error) {
      this.commonApiService.openSnackbar(
        error.error.message || 'Please upload a valid CSV file'
      );
      this.fileToUpload = null;
      this.deviceFotaForm.get('file').setValue('');
      this.fileUploaded = false;
    }
  }

  abort(e) {
    this.spinner.show();
    this.fotaApiService.abortFota(e).subscribe({
      next: (res) => {
        try {
          if (res.status) {
            this.spinner.hide();
            this.commonApiService.openSnackbar(res.message);
          }
        } catch (error) {
          this.spinner.hide();
          this.commonApiService.openSnackbar(
            error.error.message ||
              'An error occurred while processing the data.'
          );
        }
      },
      error: (err) => {
        this.spinner.hide();

        if (err.status === 406) {
          this.ngOnInit();
        }
        this.commonApiService.openSnackbar(err.error.message);
      },
      complete: () => {
        this.ngOnInit();
      },
    });
  }

  SubmitBatch() {
    if (this.deviceFotaForm.invalid) {
      SharedValidators.markAllAsTouched(this.deviceFotaForm);
      return;
    } else {
      this.uploadFotaBatch();
    }
  }

  uploadFotaBatch(): void {
    const payload = this.deviceFotaForm.value;
    payload.name = this.deviceFotaForm.get('batchName').value;
    payload.desc = this.deviceFotaForm.get('batchDescription').value;
    payload.fotaType = this.deviceFotaForm.get('type').value;
    payload.type = 'A';
    payload.userId = sessionStorage.getItem('loggedInUserId');
    this.spinner.show('loading');
    this.fotaApiService.uploadFotaBatch(this.fileToUpload, payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.spinner.hide();
          this.commonApiService.openSnackbar(res.message);
        } else {
          this.spinner.hide();
          this.commonApiService.openSnackbar('Something went wrong');
        }
      },
      error: (err) => {
        this.spinner.hide('loading');
        console.error('Error in API call:', err);
        this.commonApiService.openSnackbar(
          'Failed to fetch data. Please try again.'
        );
      },
      complete: () => {
        setTimeout(() => {
          this.spinner.hide('loading');
          this.navigateBack();
        }, 4000);
      },
    });
  }

  getfotaBatchDevicdDetails(): void {
    this.fotaApiService
      .getFotaDeviceList(
        this.myrefid,
        this.status,
        this.currentPage,
        this.pageSize,
        this.searchField
      )
      .subscribe({
        next: (res) => {
          try {
            if (res.status) {
              this.spinner.hide();
              this.fotaBatchDeviceList = res.data.batchDeviceDetail;

              if (
                (this.searchField === '' ||
                  this.searchField === null ||
                  this.searchField === undefined) &&
                this.status === ''
              ) {
                this.totalUploaded = res.totalItems;
                this.NonInitiated = res.data.noOfDevicePending;
                this.totalAborted = res.data.noOfDeviceAborted;
                this.totalCompleted = res.data.noOfDeviceCom;
                this.totalInProgress = res.data.noOfDeviceInprogress;
                this.totalInitiated = res.data.noOfDevicesInit;
                this.startFotaFlag = res.data.needStart;
              }
              this.totalCount = res.totalItems;

              this.fotaBatchDeviceList.forEach((element, index) => {
                this.fotaBatchDeviceList[index]['isinitilized'] = true;
              });
            }
          } catch (error) {
            this.fotaBatchDeviceList = [];
            this.spinner.hide();
            this.commonApiService.openSnackbar(
              error.error.message ||
                'An error occurred while processing the data.'
            );
          }
        },
        error: (err) => {
          this.fotaBatchDeviceList = [];
          this.spinner.hide();
          this.commonApiService.openSnackbar(err.error.message);
        },
        complete: () => {
          this.iSDevices = true;
          this.filter = true;
        },
      });
  }

  downloadMyFile(): void {
    if (confirm('Are You Sure?')) {
      const link: HTMLAnchorElement = document.createElement('a');
      link.setAttribute('target', '_blank');
      if (this.serverName === 'LCT-A4G') {
        link.setAttribute('href', '../../assets/Sample-FOTA-Template.csv');
        link.setAttribute('download', 'Sample-FOTA-Template.csv.csv');
      } else {
        link.setAttribute('href', '../../assets/SampleFOTATemplate.csv');
        link.setAttribute('download', 'SampleFOTATemplate.csv');
      }
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Remove the link after the download is complete
    }
  }

  onKeyUpEventBatchList(event) {
    this.currentPage = 1;
    this.searchField = event;
    this.getfotaBatchDevicdDetails();
  }

  scrollTo(status, count) {
    this.status = status;
    this.currentPage = 1;
    if (count === 0) {
      this.fotaBatchDeviceList = [];
    } else {
      this.getfotaBatchDevicdDetails();
    }
  }

  onPageChange(event) {
    this.currentPage = event;
    this.getfotaBatchDevicdDetails();
  }

  onSizeChange(newSize): void {
    this.currentPage = 1;
    this.pageSize = newSize;
    this.getfotaBatchDevicdDetails();
  }

  startFota() {
    this.spinner.show();
    this.fotaApiService.startFota(this.myrefid).subscribe({
      next: (res) => {
        try {
          if (res.status) {
            this.spinner.hide();
            this.commonApiService.openSnackbar(res.message);
          }
        } catch (error) {
          this.spinner.hide();
          this.commonApiService.openSnackbar(
            error.error.message ||
              'An error occurred while processing the data.'
          );
        }
      },
      error: (err) => {
        this.spinner.hide();
        this.commonApiService.openSnackbar(err.error.message);
      },
      complete: () => {
        this.getfotaBatchDevicdDetails();
      },
    });
  }

  navigateBack() {
    this.commonApiService.back();
  }

  // downloadBatchData() {
  //   if (confirm('Are you sure?')) {
  //     this.batchList = [];
  //     this.fotaBatchDeviceList.forEach((element) => {
  //       const row: any = {
  //         UIN: element['uin'],
  //         IMEI: element['imei'],
  //         // MODEL: element['model'],
  //         FOTA_TYPE: element['fotaType'],
  //         STATE: element['state'],
  //         ACCOLADE_FIRMWARE_VERSION: element['af'],
  //         UPCOMING_FIRMWARE_VERSION: element['ufw'],
  //         LAST_LOGIN: element['lastlogin'],
  //         FOTA_STATUS: element['fotaStatus'],
  //         IP_STATUS: element['stateIpStatus'],
  //         STATE_IP_RESPONSE: element['stateIpRes'],
  //         STATE_ENABLE_OTA: element['stateEnbOta'],
  //       };
  //       if (this.serverName === 'LCT-A4G') {
  //         row.OPEN_CPU_VERSION = element['openCpuVer'];
  //         row.OPEN_CPU_STATUS = element['openCpuStatus'];
  //       }
  //       this.batchList.push(row);
  //     });
  //     this.commonApiService.createCSVFile(this.batchList, 'Fota_Batch');
  //   }
  // }
  downloadBatchData() {
    if (this.isDownloading) {
      this.commonApiService.openSnackbar(
        'Download in progress, please wait...'
      );
      return;
    }
    if (confirm('Are you sure?')) {
      try {
        this.batchList = [];

        this.fotaBatchDeviceList.forEach((element) => {
          let row: any = {};

          // ───────────────── LCT-A4G FORMAT ─────────────────
          if (this.serverName === 'LCT-A4G') {
            row = {
              // ── FotaBatchHeader ───────────────────────────
              BATCH_ID: element['batchId'],
              BATCH_NAME: element['batchName'],

              // ── FotaDeviceDetail ──────────────────────────
              IMEI: element['imei'],
              STATE: element['state'],
              FOTA_TYPE: element['fotaType'],

              OPEN_CPU_VERSION: element['openCpuVer'],
              OPEN_CPU_STATUS: element['openCpuStatus'],
              OpenCPU_RETRY_COUNT: element['cpuRetryCount'] ?? '--',
              MCU_VERSION: element['ufw'],
              MCU_STATUS: element['mcuStatus'],
              MCU_RETRY_COUNT: element['mcuRetryCount'] ?? '--',

              TRIGGER_ORDER: element['triggerOrder'] ?? '--',
              Overall_FOTA_STATUS: element['overallFotaStatus'],

              CREATED_BY: element['createdByName'] ?? '--',
            };
          }

          // ───────────────── OTHER SERVER FORMAT ─────────────────
          else {
            row = {
              BATCH_ID: element['batchId'] ?? '--',
              BATCH_NAME: element['batchName'] ?? '--',
              STATE: element['state'],
              FOTA_TYPE: element['fotaType'],
              // UIN: element['uin'],
              IMEI: element['imei'],

              CURRENT_FIRMWARE_VERSION: element['af'],
              UPCOMING_FIRMWARE_VERSION: element['ufw'],

              // STATE_ENABLE_OTA: element['stateEnbOta'],
              FOTA_STATUS: element['mcuStatus'],
              FOTA_Percentage: element.fotaPercentage ?? '--',
              FOTA_RETRY_COUNT: element.mcuRetryCount ?? '--',
              IP_STATUS: element['stateIpStatus'],
              STATE_IP_RESPONSE: element['stateIpRes'],
              Overall_FOTA_STATUS: element['overallFotaStatus'],
              BATCH_TIME: element['createdAt'],
              CREATED_BY: element['createdByName'] ?? '--',
            };
          }

          this.batchList.push(row);
        });

        this.commonApiService.createCSVFile(this.batchList, 'Fota_Batch');
      } finally {
        this.isDownloading = false;
      }
    }
  }
}
